import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timerFormat'
})
export class TimerFormatPipe implements PipeTransform {

  transform(value: number): string {
    if (value == null || value == 0) return '0';
    return `${Math.floor(value / 60)}:${value % 60}`;
  }

}


